import styled from 'styled-components';

export const StyledMainPage = styled.div`
  margin: 0;
`;
